module.exports = __webpack_public_path__ + "img/mgh-nihonbashi-premier.38e6cbf9.jpg";